module.exports = __webpack_public_path__ + "static/media/sarah.3806f31f.jpg";